/*
 * landing-faq-accordion.js
 *
 * Enforces single-open accordion behaviour on any FAQ group marked with
 * [data-faq-accordion]: only one <details> stays open at a time.
 *
 * Progressive enhancement — the server may render several <details open>
 * (so the answers are present in the DOM for crawlers and the no-JS case);
 * on load we collapse to a single open item and bind toggle handlers.
 *
 * Works for both FAQ markups in the theme:
 *   - shared .landing-faq      (snippet landing-faq + section landing-faq-section)
 *   - Track-B custom markup     (.elast__faq, .helic__faq, etc.)
 *
 * Idempotent: guarded so it binds once even if the asset is included by more
 * than one section on the same page.
 */
(function () {
  if (window.__surisaFaqAccordion) return;
  window.__surisaFaqAccordion = true;

  function bind(group) {
    if (group.__faqBound) return;
    group.__faqBound = true;

    var items = Array.prototype.slice.call(group.querySelectorAll('details'));
    if (!items.length) return;

    // Collapse to the first open item (or none) on load.
    var keptOpen = false;
    items.forEach(function (d) {
      if (d.open) {
        if (keptOpen) d.open = false;
        else keptOpen = true;
      }
    });

    // Opening one closes the rest. Closing the open one is allowed (0 open).
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) {
          if (o !== d && o.open) o.open = false;
        });
      });
    });
  }

  function init() {
    var groups = document.querySelectorAll('[data-faq-accordion]');
    Array.prototype.forEach.call(groups, bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
